<mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
  <mat-card-content fxLayout="column"  fxLayoutAlign="start center">
    <div fxFlex class="filter w-100" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-sm="column">
      <mat-form-field class="accent">
        <mat-label>Search accessory bundles</mat-label>
        <input matInput type="text"
          [(ngModel)]="searchTerm"
          (keyup.enter)="loadData()"
          (keyup.esc)="searchTerm=''; loadData()"
          name="searchTerm"
          placeholder="Search Name">
        <button mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="searchTerm=''; loadData()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <div fxLayout="row" fxLayoutGap="10px">
        <button
          type="submit"
          mat-flat-button color="primary"
          (click)="loadData()"
          matTooltip="Search"
          [class.button-spinner]="loading"
          [disabled]="loading">
          <mat-icon>search</mat-icon> Search
        </button>
        <button mat-flat-button color="accent" (click)="add()">
          <mat-icon>add</mat-icon> Add
        </button>
      </div>
    </div>
    <div class="m-b-20 w-100" fxFlex="100">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
        <small class="text-info"><i>filter:</i></small>
        <mat-chip-list #optionChipList>
          <mat-chip *ngIf="searchTerm" class="green-chip" color="accent">
            <span>{{searchTerm}}</span>
            <button matChipRemove (click)="searchTerm = undefined; loadData();">
              <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
            </button>
          </mat-chip>
        </mat-chip-list>
      </div>
    </div>
  </mat-card-content>
</mat-card>
<mat-card>
  <mat-card-content>
    <div *ngIf="data.length === 0 && !loading" class="empty-state" fxLayout="column" fxLayoutAlign="center center">
      <mat-icon class="empty-icon">inbox</mat-icon>
      <p class="text-muted">No accessory bundles found</p>
    </div>
    <div *ngFor="let item of data">
      <mat-card class="contrast" [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
        <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
          <div fxFlex="80" fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="10px">
            <strong [ngClass.lt-sm]="{'card-title': true}" [innerHtml]="item?.name | highlight: searchTerm"></strong>
            <small class="text-info" *ngIf="item?.buildingInstructions">{{ item.buildingInstructions }}</small>
          </div>
          <div fxFlex="20" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
            <div fxFlex="100" fxLayoutAlign="end center" fxLayout="row">
              <button mat-icon-button color="accent" aria-label="Edit Accessory Bundle" matTooltip="Edit Accessory Bundle" (click)="onClickAccessoryBundle(item)">
                <mat-icon>edit</mat-icon>
              </button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </mat-card-content>
</mat-card>